export default __webpack_public_path__ + "static/media/arrow.1434b9ec.svg";